import { List, type ListProps } from '@src/shared/ui/List';

const StyleSheet = {
  root: {
    padding: 0,
  },
};

function SidebarGroup(props: ListProps) {
  return <List {...props} sx={StyleSheet.root} />;
}

SidebarGroup.displayName = 'SidebarGroup';
export default SidebarGroup;
